import React, { useContext, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import useFormValidator from 'useFormValidator';
import InputMask from 'react-input-mask';
// import { isNumber } from 'helper';
import DateInputPicker from 'modules/common/components/DateInputPicker2';
import moment from 'moment';
import Select from 'react-select';
import { customStyle } from 'helper';

import * as actions from '../action';
import * as c from '../constant';

function UpdateModal({
  createInput,
  createInputNumber,
  createSelect,
  updateCdl,
  showTransaction,
  formData,
  updateList,
  setFormData,
  transactId,
  validId,
  updating,
  moduleId,

  getBarangayList,
  barangayList,

  // getBusinessLines,
  // businessLinesList,
  getBusinessNatures,
  businessNaturesList,
}) {
  const setModal = useContext(ModalContext);

  const handleOnSubmit = (e) => {
    e.preventDefault();

    const args = {
      ...formData,
      module_id: moduleId,
    };
    updateCdl(moduleId, args, () => {
      setModal({ isOpen: false });
      showTransaction(transactId);
    });
  };

  const closeModal = (e) => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  const onSetFormData = () => {
    if (!_.isEmpty(updateList)) {
      const args = {
        ...updateList,
        valid_id_to_present: validId,
      };
      setFormData(_.pick(args, _.keys(c.CEDULA_EDIT_FORM)));
    }
  };

  useEffect(() => {
    // getBusinessLines()
    getBusinessNatures(
      _.get(
        updateList,
        'line_business_id',
      )
    )
    getBarangayList({
      municipality_code: _.get(
        updateList,
        'municipality_code',
      ),
    });
  }, []);

  useEffect(() => {
    setFormData({
      ...formData,
      cedula_amount_1: (_.get(formData, 'total_assessed_value_of_real_property') / 2500),
      cedula_amount_2: (_.get(formData, 'total_earnings_from_business') / 2500),
    })
  }, [formData.total_assessed_value_of_real_property, formData.total_earnings_from_business, ])

  useEffect(() => {
    onSetFormData();
  }, {});

  const commonValidation = {
    tin: 'required|tax_payer_account_number',
  }

  const validateForm = useFormValidator(
    formData,
    commonValidation,
  );

  useEffect(() => {
    validateForm.onSetObjectRules(commonValidation)
  }, [])

  useEffect(() => {
    validateForm.validate();
  }, [Object.values(formData).join(',')]);

  const handleOnChangeDate = (key) => ({ target: { value } }) => {
    setFormData({
      ...formData,
      [key]: value,
    });
  };

  const createDropdown = list => {
    const newList = [];
    list.map(data => {
      return newList.push({
        label: data.attributes.name,
        value: data.attributes.code,
      });
    });
    return newList;
  };

  /* eslint-disable eqeqeq */
  const getSelectedOptions = (list, value) => {
    return createDropdown(list).find(x => x.value == value) || {};
  };

  // const handleRegionSelect = e => {
  //   setFormData({
  //     ...formData,
  //     region_code: e.value,
  //   });
  //   getProvinceList({ region_code: e.value });
  // };

  const handleBarangaySelect = e => {
    setFormData({
      ...formData,
      barangay_code: e.value,
    });
  };

  const handleBusinessNaturesSelect = e => {
    setFormData({
      ...formData,
      nature_of_business_code: e.value,
      nature_of_business_name: e.label
    });
  };

  // const handleBirthplaceProvinceSelect = e => {
  //   setFormData({
  //     ...formData,
  //     place_of_birth_province_code: e.value,
  //   });
  //   getMunicipalityList({ province_code: e.value });
  // };

  // const handleBirthplaceMunicipalitySelect = e => {
  //   setFormData({
  //     ...formData,
  //     place_of_birth_municipality_code: e.value,
  //   });
  //   getBarangayList({ municipality_code: e.value });
  // };

  // const handleBirthplaceBarangaySelect = e => {
  //   setFormData({
  //     ...formData,
  //     place_of_birth_barangay_code: e.value,
  //   });
  // };

  const handleOnChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]:
        e.target.type === 'checkbox' ? e.target.checked : e.target.value,
    });
  };

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="row">
          <label className="col-12 form-group">
            {' '}
            Document Owner&apos;s Information{' '}
          </label>

          <div className="col-6 form-group">
            {createInput({ key: 'president_authorized_representative', label: 'President/Authorized Representative:' })}
          </div>
          <div className="col-6 form-group">
            {createInput({ key: 'name_of_corporation_partnership', label: 'Name of Corporation/Partnership:' })}
          </div>
          <div className="col-6 pt-1">
            <label className="form-label">Select Barangay:
              <span className="text-danger"> <i>Required</i> </span>
            </label>
            <div>
              <Select
                options={createDropdown(barangayList)}
                styles={customStyle}
                placeholder="Select Barangay"
                value={getSelectedOptions(barangayList, formData.barangay_code)}
                onChange={e => {
                  handleBarangaySelect(e)
                }}
              />
            </div>
          </div>
          <div className="col-6 form-group">
            {createInput({ key: 'street', label: 'Street:' })}
          </div>
          <div className="col-6 form-group">
            <label className="form-label">Date of Registration:</label>
            <DateInputPicker
              className="full-input"
              onChange={handleOnChangeDate('date_of_registration')}
              value={
                `${moment(_.get(formData, 'date_of_registration')).format(
                  'MM-DD-YYYY HH:mm'
                )}:00` || ''
              }
              maxDate={new Date()}
            />
          </div>
          <div className="col-6 form-group">
            {createInput({ key: 'place_of_registration', label: 'Place of Registration:', isReadOnly: true })}
          </div>
          <div className="col-6 form-group">
            <label htmlFor="last_name" className="form-label">Tax Payer Account No.: {validateForm.renderMessage('tin')}</label>
            <InputMask
              className="form-control"
              mask="999-999-999-99999"
              alwaysShowMask
              type="text"
              name="tin"
              onChange={handleOnChange}
              value={_.get(formData, 'tin')}
            />
          </div>
          <div className="col-6 form-group">
            {createSelect(
              {
                key: 'valid_id_to_present',
                label: 'Valid ID:',
              },
              c.VALID_IDS
            )}
          </div>
          {/* <div className="col-6 pt-1">
            <label className="form-label">Line of Business:
              <span className="text-danger"> <i>Required</i> </span>
            </label>
            <div>
              <Select
                options={createDropdown(businessLinesList)}
                styles={customStyle}
                placeholder="Select Barangay"
                value={getSelectedOptions(businessLinesList, formData.line_business_id)}
                onChange={e => {
                  handleBarangaySelect(e)
                }}
              />
            </div>
          </div> */}
          <div className="col-6 form-group">
            <label className="form-label">Nature of Business:
              <span className="text-danger"> <i>Required</i> </span>
            </label>
            <div>
              <Select
                options={createDropdown(businessNaturesList)}
                styles={customStyle}
                placeholder="Select Barangay"
                value={getSelectedOptions(businessNaturesList, formData.nature_of_business_code)}
                onChange={e => {
                  handleBusinessNaturesSelect(e)
                }}
              />
            </div>
          </div>
          <label className="col-12 form-group">
            {' '}
            Cedula / Community Tax Certificate{' '}
          </label>
          <div className="col-12 font-weight-bold">
            Total assessed value of Real Property
          </div>
          <div className="col-3 form-group">
            {createInputNumber({ key: 'total_assessed_value_of_real_property', label: 'Taxable Amount:' })}
          </div>
          <div className="col-3 form-group">
            {createInputNumber({ key: 'cedula_amount_1', label: 'Cedula Amount:', isReadOnly: true })}
          </div>
          <div className="col-12 font-weight-bold">
           Total gross earnings from business
          </div>
          <div className="col-3 form-group">
            {createInputNumber({ key: 'total_earnings_from_business', label: 'Taxable Amount:' })}
          </div>
          <div className="col-3 form-group">
            {createInputNumber({ key: 'cedula_amount_2', label: 'Cedula Amount:', isReadOnly: true })}
          </div>
        </div>
        <div className="d-flex justify-content-center">
          <button
            disabled={updating}
            type="submit"
            className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary  mr-3"
          >
            <span className="font-weight-bold">
              {updating ? <i className="fa fa-spin fa-spinner" /> : `Submit`}
            </span>
          </button>
          <button
            disabled={updating}
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark "
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

UpdateModal.propTypes = {
  createInput: PropTypes.instanceOf(Function).isRequired,
  createInputNumber: PropTypes.instanceOf(Function).isRequired,
  createSelect: PropTypes.instanceOf(Function).isRequired,
  updateList: PropTypes.instanceOf(Object).isRequired,
  setFormData: PropTypes.instanceOf(Function).isRequired,
  formData: PropTypes.instanceOf(Object).isRequired,
  showTransaction: PropTypes.instanceOf(Function).isRequired,
  updateCdl: PropTypes.instanceOf(Function).isRequired,
  moduleId: PropTypes.string.isRequired,
  transactId: PropTypes.string.isRequired,
  validId: PropTypes.string.isRequired,
  updating: PropTypes.bool.isRequired,

  getBarangayList: PropTypes.instanceOf(Function).isRequired,
  barangayList: PropTypes.instanceOf(Array).isRequired,
  // getBusinessLines: PropTypes.instanceOf(Function).isRequired,
  // businessLinesList: PropTypes.instanceOf(Array).isRequired,
  getBusinessNatures: PropTypes.instanceOf(Function).isRequired,
  businessNaturesList: PropTypes.instanceOf(Array).isRequired,
};

const mapStateToProps = ({ api }) => ({
  updating: api.loading.indexOf(c.UPDATE_TRANSACTION) > -1,
  barangayList: _.get(api, `${c.GET_BARANGAYS}.list`) || [],
  // businessLinesList: _.get(api, `${c.GET_BUSINESS_LINES}.list`) || [],
  businessNaturesList: _.get(api, `${c.GET_BUSINESS_NATURE}.list`) || [],
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(UpdateModal);
